var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSingleAndi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5454 8.55133C10.9726 8.55133 12.9402 6.63705 12.9402 4.27566C12.9402 1.91428 10.9726 0 8.5454 0C6.11823 0 4.15062 1.91428 4.15062 4.27566C4.15062 6.63705 6.11823 8.55133 8.5454 8.55133ZM12.8709 24.8622H4.12204V27H0.012107V19.5176C0.012107 19.4834 0.0104923 19.4349 0.00844232 19.3734C-0.0203815 18.5078 -0.13527 15.0579 2.94196 12.4707C6.23805 9.6994 11.2025 10.0161 14.0103 12.4707C16.8181 14.9252 17.0894 17.9868 16.9808 19.5176V27H12.8709V24.8622ZM12.8709 20.9428H4.12203V18.7654C4.14916 17.3402 5.05795 14.4898 8.47611 14.4898C11.8943 14.4898 12.8302 17.3402 12.8709 18.7654V20.9428Z",
    fill: "#FF233C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleAndi);
export default __webpack_public_path__ + "static/media/singleAndi.4e0d4d71a3018941cc8de8e6382a9a42.svg";
export { ForwardRef as ReactComponent };